module.exports = {
    posts: {
        en: "Posts",
        fi: "Ilmoitukset"
    },
    title: {
        en: "Please fill or select one or many fields for searching",
        fi: "Täytä tai valitse useampi kenttä etsiäksesi"
    },
    selectTypes: {
        en: "Select types",
        fi: "Valitse tyypit"
    },
    selectSubTypes: {
        en: "Select sub-types",
        fi: "Valitse alityypit"
    },
    selectMakers: {
        en: "Select makers",
        fi: "Valitse valmistaja"
    },
    selectCountries: {
        en: "Select countries",
        fi: "Valitse maat"
    },
    selectProvinces: {
        en: "Select provinces",
        fi: "Valitse maakunnat"
    },
    selectCities: {
        en: "Select cities",
        fi: "Valitse kaupungit"
    },
    selectFrameSizes: {
        en: "Select frame sizes",
        fi: "Valitse rungot"
    },
    selectGears: {
        en: "Select gears",
        fi: "Valitse vaihteistot"
    },
    selectTyreTypes: {
        en: "Select tyre types",
        fi: "Valitse renkaat"
    },
    selectMaterials: {
        en: "Select materials",
        fi: "Valitse materiaalit"
    },
    selectBreakTypes: {
        en: "Select break types",
        fi: "Valitse jarrut"
    },
    selectSuspensionTypes: {
        en: "Select suspension types",
        fi: "Valitse jousitukset"
    },
    selectGenders: {
        en: "Select genders",
        fi: "Valitse sukupuoli"
    },
    selectNumOfWheels: {
        en: "Select number of wheels",
        fi: "Valitse renkaiden lukumäärä"
    },
    selectWheelSizes: {
        en: "Select wheel sizes",
        fi: "Valitse renkaiden koko"
    },
    selectMudGuardTypes: {
        en: "Select mud guard types",
        fi: "Valitse lokasuojat"
    },
    selectRackTypes: {
        en: "Select rack types",
        fi: "Valitse tarakan tyyppi"
    },
    selectBasketTypes: {
        en: "Select basket types",
        fi: "Valitse korin tyyppi"
    },
    isLockIncluded: {
        en: "Is lock included",
        fi: "Kuuluuko pyöränlukko kauppaan"
    },
    isLockIncludedToolTip: {
        en: "Lock is optional",
        fi: "Lukko on valinnainen"
    },
    isFrontLightIncluded: {
        en: "Is front light included",
        fi: "Kuuluuko etuvalo kauppaan"
    },
    isFrontLightIncludedToolTip: {
        en: "Front light is optional",
        fi: "Etuvalo on valinnainen"
    },
    isRareLightIncluded: {
        en: "Is rare light included",
        fi: "Kuuluuko takavalo kauppaan"
    },
    isRareLightIncludedToolTip: {
        en: "Front light is optional",
        fi: "Takavalo on valinnainen"
    },
    legStandExist: {
        en: "Leg stand exists",
        fi: "Pyöränjalka"
    },
    legStandExistToolTip: {
        en: "Leg stand is optional",
        fi: "Pyöränjalka on valinnainen"
    },
    yes: {
        en: "Yes",
        fi: "Kyllä"
    },
    no: {
        en: "No",
        fi: "Ei"
    },
    notSure: {
        en: "Not sure",
        fi: "En ole varma"
    },
    priceStart: {
        en: "Price start €",
        fi: "Hinta alkaen €"
    },
    priceStartPlaceholder: {
        en: "Price start € here",
        fi: "Hinta alkaen € täällä"
    },
    priceEnd: {
        en: "Price end €",
        fi: "Hinta päättyen €"
    },
    priceEndPlaceholder: {
        en: "Price end € here",
        fi: "Hinta päättyen € täällä"
    },
    textSearch: {
        en: "Text search",
        fi: "Tekstihaku"
    },
    textSearchPlaceholder: {
        en: "Text search here",
        fi: "Tekstihaku täällä"
    },
    search: {
        en: "Search",
        fi: "Haku"
    },
    otherTitle: {
        en: "Please fill one or many fields for searching",
        fi: "Täytä yksi tai useampi kenttä hakeaksesi"
    },
    nameOfTheSeller: {
        en: "Name of the seller",
        fi: "Myyjän nimi"
    },
    selectACountry: {
        en: "Select a country",
        fi: "Valitse maa"
    },
    selectACountryToolTip: {
        en: "Country is optional",
        fi: "Maa on valinnainen"
    },
    selectAProvince: {
        en: "Select a province",
        fi: "Valitse maakunta"
    },
    selectAProvinceToolTip: {
        en: "Province is optional",
        fi: "Maakunta on valinnainen"
    },
    selectACity: {
        en: "Select a city",
        fi: "Valitse kaupunki"
    },
    selectACityToolTip: {
        en: "City is optional",
        fi: "Kaupunki on valinnainen"
    },
    loadMore: {
        en: "Load more",
        fi: "Lataa lisää"
    },
    userNotFound: {
        en: "User not found",
        fi: "Käyttäjä ei löytynyt"
    }
};